exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.show-automation .ant-form-item {\n  margin-bottom: 15px !important;\n}\n.show-automation .ant-form-item-control, .show-automation .ant-form-item-label {\n  line-height: 1.5 !important;\n}\n", ""]);

// exports
